import { CurrencyFormat } from "components/CurrencyFormat";
import styles from "./payment-methods.module.scss";

export const InPerson = ({ paymentInfo }) => (
  <>
    <div className={styles.headText}>
      You can pay in person by presenting your {paymentInfo.item_to_present} at
      any {paymentInfo.business_name}.
    </div>
    <div className={styles.headText}>
      Payments can be made by cash or EFTPOS. Payment can’t be made by credit
      card or charge card
      {paymentInfo.fee && paymentInfo.fee > 0 ? (
        <>
          {" "}
          and a payment handling fee of{" "}
          <CurrencyFormat value={paymentInfo.fee} /> will apply.
        </>
      ) : (
        "."
      )}
    </div>
  </>
);
